import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'hd-spinner',
  standalone: true,
  imports: [],
  templateUrl: './spinner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './spinner.component.scss',
})
export class SpinnerComponent {}
